<div class="page-block">
    <a class="close" (click)="close()">
		<i class="fa fa-times"></i>
    </a>
    
    <h2 class="mat-title">Please Confirm</h2>
    
    <div class="text-center">
        <p>Are you sure you want to delete this image?</p>
        <button class="btn btn-danger" (click)="confirm()">Delete</button>
    </div>
    
</div>

